import { render, staticRenderFns } from "./uploadFrame.vue?vue&type=template&id=0da81aa8&scoped=true&"
import script from "./uploadFrame.vue?vue&type=script&lang=js&"
export * from "./uploadFrame.vue?vue&type=script&lang=js&"
import style0 from "./uploadFrame.vue?vue&type=style&index=0&id=0da81aa8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da81aa8",
  null
  
)

export default component.exports